module.exports = __webpack_public_path__ + "img/cafoscari-black.356e1275.svg";